import React from "react"

import { container } from "../utils/styles"

// TODO: look at where this is used and consider
// renaming to main/primary/etc container
const Container = ({ children, ...rest }) => (
  <div
    css={theme => [
      container(theme),
      {
        "> div": {
          width: "100%",
        },
      },
    ]}
    {...rest}
  >
    <div>{children}</div>
  </div>
)

export default Container
